// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"95eaeabb","680":"e8f41f34","788":"ba9e0c06"}[chunkId] + ".chunk.js";
};